export class EatingType {
    static eatings = ['Завтрак', 'Обед', 'Ужин', 'Перекус'];
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/EatingTypes.ts